import React, { useState, useEffect } from 'react';
import { fetchWithCSRF } from '../../utils/csrfUtils';
import supabase from '../../supabaseClient';

function IngredientForm() {
    const [ingredient, setIngredient] = useState({
        name: '',
        description: '',
        image_url: '',
        estimated_shelf_life: '',
        protein: '',
        carbohydrate: '',
        fat: '',
        micronutrients: '',
        estimated_cost_per_unit_cents: '',
        common_uses: '',
        is_perishable: true,
        is_vegetarian: false,
        is_vegan: false,
        calories_per_base_unit: '',
        serving_size: '',
        author_id: '',
    });

    const [unitOptions, setUnitOptions] = useState([]);
    const [sessionToken, setSessionToken] = useState('');

    //get the current session for the auth token (useEffect)
    useEffect(() => {
        const getSessionToken = async () => {
        const { data: { session } } = await supabase.auth.getSession();
            if (session?.access_token) {
                console.log("sessionToken: " + session.access_token);
                setSessionToken(session.access_token);
            }
        }
        getSessionToken();
    }, []);

    

    useEffect(() => {
        if (sessionToken) {
            // Fetch unit of measurement options
            fetchWithCSRF('/api/v1/ingredient/unit_of_measurement_enum', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${sessionToken}`
                }
            })
                .then(response => response.json())
                .then(data => {
                    const units = data.map(item => item.unit); // Extract unit values
                    setUnitOptions(units);
                })
                .catch(error => console.error('Error fetching unit options:', error));
        }
    }, [sessionToken]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setIngredient({
            ...ingredient,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetchWithCSRF('/api/v1/ingredient', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionToken}`
                },
                body: JSON.stringify(ingredient),
            });
            if (response.ok) {
                alert('Ingredient created successfully!');
                setIngredient({
                    name: '',
                    description: '',
                    image_url: '',
                    estimated_shelf_life: '',
                    protein: '',
                    carbohydrate: '',
                    fat: '',
                    micronutrients: '',
                    estimated_cost_per_unit_cents: '',
                    common_uses: '',
                    is_perishable: true,
                    is_vegetarian: false,
                    is_vegan: false,
                    calories_per_base_unit: '',
                    serving_size: '',
                    author_id: '',
                });
            } else {
                //log request body to console
                console.log(ingredient);
                alert('Failed to create ingredient.');
            } 
        } catch (error) {
            console.error('Error creating ingredient:', error);
        }

    };

    return (
        <div className="container">
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        value={ingredient.name}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="description">Description</label>
                    <textarea
                        className="form-control"
                        id="description"
                        name="description"
                        value={ingredient.description}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="image_url">Image URL</label>
                    <input
                        type="text"
                        className="form-control"
                        id="image_url"
                        name="image_url"
                        value={ingredient.image_url}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="unit_of_measurement">Unit of Measurement</label>
                    <select
                        className="form-control"
                        id="unit_of_measurement"
                        name="unit_of_measurement"
                        value={ingredient.unit_of_measurement}
                        onChange={handleChange}
                    >
                        <option value="">Select a unit</option>
                        {unitOptions.map(option => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    <label htmlFor="estimated_shelf_life">Estimated Shelf Life (Days)</label>
                    <input
                        type="text"
                        className="form-control"
                        id="estimated_shelf_life"
                        name="estimated_shelf_life"
                        value={ingredient.estimated_shelf_life}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="protein">Protein</label>
                    <input
                        type="number"
                        className="form-control"
                        id="protein"
                        name="protein"
                        value={ingredient.protein}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="carbohydrate">Carbohydrate</label>
                    <input
                        type="number"
                        className="form-control"
                        id="carbohydrate"
                        name="carbohydrate"
                        value={ingredient.carbohydrate}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="fat">Fat</label>
                    <input
                        type="number"
                        className="form-control"
                        id="fat"
                        name="fat"
                        value={ingredient.fat}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="micronutrients">Micronutrients</label>
                    <input
                        type="text"
                        className="form-control"
                        id="micronutrients"
                        name="micronutrients"
                        value={ingredient.micronutrients}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="estimated_cost_per_unit_cents">Estimated Cost Per Unit (in cents)</label>
                    <input
                        type="text"
                        className="form-control"
                        id="estimated_cost_per_unit_cents"
                        name="estimated_cost_per_unit_cents"
                        value={ingredient.estimated_cost_per_unit_cents}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="common_uses">Common Uses</label>
                    <input
                        type="text"
                        className="form-control"
                        id="common_uses"
                        name="common_uses"
                        value={ingredient.common_uses}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-check">
                    <label htmlFor="is_perishable">Is Perishable</label>
                    <input
                        type="checkbox"
                        className="form-check-input"
                        id="is_perishable"
                        name="is_perishable"
                        checked={ingredient.is_perishable}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-check">
                    <label htmlFor="is_vegetarian">Is Vegetarian</label>
                    <input
                        type="checkbox"
                        className="form-check-input"
                        id="is_vegetarian"
                        name="is_vegetarian"
                        checked={ingredient.is_vegetarian}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-check">
                    <label htmlFor="is_vegan">Is Vegan</label>
                    <input
                        type="checkbox"
                        className="form-check-input"
                        id="is_vegan"
                        name="is_vegan"
                        checked={ingredient.is_vegan}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="calories_per_base_unit">Calories Per Base Unit</label>
                    <input
                        type="text"
                        className="form-control"
                        id="calories_per_base_unit"
                        name="calories_per_base_unit"
                        value={ingredient.calories_per_base_unit}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="serving_size">Serving Size</label>
                    <input
                        type="text"
                        className="form-control"
                        id="serving_size"
                        name="serving_size"
                        value={ingredient.serving_size}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="author_id">Author ID</label>
                    <input
                        type="text"
                        className="form-control"
                        id="author_id"
                        name="author_id"
                        value={ingredient.author_id || "system"}
                        onChange={handleChange}
                    />
                </div>
                <button type="submit" className="btn btn-primary">Add Ingredient</button>
            </form>
        </div>
    );

}

export default IngredientForm;
